import { styled, Tab, Tabs } from "@mui/material";

export const VerticalTabs = styled(Tabs)(({ theme }) => ({
  flexGrow: 1,
  flexDirection: "column",
  "& .MuiTabs-flexContainer": {
    flexDirection: "column",
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

export const MyTab = styled(Tab)(({ theme }) => ({
  borderRight: "1px solid #d1d1d1",
  "&.Mui-selected": {
    color: "#253257",
    borderRight: "0",
    borderBottom: "1px solid #d1d1d1",
    borderTop: "1px solid #d1d1d1",
  },
}));
